import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toggleMobileNavVisibility } from "../../reducers/Layout";
import * as GlobalFunc from "../../utils/globalFunc";
import * as Business from "../../utils/business";
import { getLang, setLang, onLangChange } from "../../i18n";

const ROUTE_LABELS = {
  car: "CAR",
  "capital-planning": "Capital Planning",
  icaap: "ICAAP",
  "master-table": "Master Table",
  config: "Config",
  user: "User Management",
  role: "Role Management",
  activities: "Activities",
  dashboard: "Dashboard",
  raroc: "RAROC",
  pricing: "Pricing",
  "validate-result": "Validate Result",
  "upload-file": "Upload File",
  "file-management": "File Management",
  reports: "Reports",
  report: "Report",
  calculation: "Calculation",
  result: "Result",
};

function parsePathCrumbs(pathname) {
  return (pathname || "/")
    .replace(/^\//, "")
    .split("/")
    .filter(Boolean)
    .map(function (seg) {
      return (
        ROUTE_LABELS[seg] ||
        seg.replace(/-/g, " ").replace(/\b\w/g, function (c) {
          return c.toUpperCase();
        })
      );
    });
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { lang: getLang() };
    this._unsubscribe = null;
  }

  componentDidMount() {
    this._unsubscribe = onLangChange((lang) => this.setState({ lang }));
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  render() {
    const { toggleMobileNavVisibility, location } = this.props;
    const { lang } = this.state;
    var crumbs = parsePathCrumbs(location ? location.pathname : "/");
    var fullName = Business.getAccountFullName() || "Administrator";
    var roleName = Business.getCurrentRoleGroupName() || "";
    var initials =
      fullName
        .split(" ")
        .filter(Boolean)
        .map(function (n) {
          return n[0];
        })
        .join("")
        .toUpperCase()
        .slice(0, 2) || "AD";
    var now = new Date();
    var monthStr = now.toLocaleDateString("en-GB", {
      month: "short",
      year: "numeric",
    });

    return (
      <div className="ey-topbar">
        <div className="ey-topbar-left">
          <button
            className="ey-topbar-hamburger"
            type="button"
            onClick={toggleMobileNavVisibility}
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
          <ol className="ey-topbar-breadcrumb">
            <li>Home</li>
            {crumbs.map(function (c, i) {
              return (
                <li
                  key={i}
                  className={i === crumbs.length - 1 ? "ey-crumb-active" : ""}
                >
                  {c}
                </li>
              );
            })}
          </ol>
        </div>
        <div className="ey-topbar-right">
          <div className="ey-topbar-period">
            <i className="pe-7s-date" />
            <span>{monthStr}</span>
          </div>
          <div className="ey-lang-switcher">
            <button
              className={
                "ey-lang-btn" + (lang === "vi" ? " ey-lang-btn--active" : "")
              }
              onClick={() => setLang("vi")}
              type="button"
              title="Tiếng Việt"
            >
              🇻🇳 VI
            </button>
            <button
              className={
                "ey-lang-btn" + (lang === "en" ? " ey-lang-btn--active" : "")
              }
              onClick={() => setLang("en")}
              type="button"
              title="English"
            >
              🇺🇸 EN
            </button>
          </div>
          <button
            className="ey-topbar-icon-btn"
            type="button"
            title="Notifications"
          >
            <i className="pe-7s-bell" />
          </button>
          <div className="ey-topbar-user">
            <div className="ey-topbar-avatar">{initials}</div>
            <div className="ey-topbar-userinfo">
              <span className="ey-topbar-name">{fullName}</span>
              {roleName && <span className="ey-topbar-role">{roleName}</span>}
            </div>
          </div>
          <button
            className="ey-topbar-logout"
            type="button"
            onClick={function () {
              GlobalFunc.logout();
            }}
          >
            <i className="pe-7s-power" />
            <span>Log out</span>
          </button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProp = (dispatch) => ({
  toggleMobileNavVisibility: () => dispatch(toggleMobileNavVisibility()),
});

export default withRouter(connect(null, mapDispatchToProp)(Header));



// WEBPACK FOOTER //
// src/pages/Main/Header.js